import { jsonp } from 'utils/request';
import config from '$config';

// 我的红包列表查询接口
export async function fetchMyPackageInfo() {
  return await jsonp(
    `${config.PROMOTION_ENDPOINT}/promotion/ambassador/queryAmbassadorRebateOrder.htm`,
    {
      orderBizTypeList: '6,7',
      page: 1,
      orderByClause: 'id',
      pageSize: 1000,
    },
    { jsonpCallback: 'cback' }
  );
}

//收取红包接口
export async function fetchReceivePackage(id) {
  return await jsonp(
    `${config.PROMOTION_ENDPOINT}/promotion/ambassador/openAmbassadorOrderPrize.htm`,
    {
      rebateStatus: 3,
      id,
    },
    { jsonpCallback: 'cback' }
  );
}



// WEBPACK FOOTER //
// ./src/scripts/services/TeamInfoService.js